import * as postProcess from "@lts/post-processes/legacy/legacy";
export { postProcess };
export default postProcess;
